module.exports = __webpack_public_path__ + "img/channel_communication_between_goroutines.869158ee.png";